export default __webpack_public_path__ + "static/media/papernest.d679b5d7.jpg";